
import { css } from 'lit';
export default css`
.caption {
    font-family: Lato, sans-serif;
    font-size: 0.9375rem
}
`;